import { render, staticRenderFns } from "./electrical-engineering-3.vue?vue&type=template&id=2348f37a&"
import script from "./electrical-engineering-3.vue?vue&type=script&lang=js&"
export * from "./electrical-engineering-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports